
const namespaced = true;

const state = {
  challengingInterventionId: null,
  challengingIntervention: {},
};

const mutations = {
  SET_CHALLENGING_INTERVENTION_ID(state, interventionId) {
    state.interventionId = interventionId;
  },
  SET_CHALLENGING_INTERVENTION(state, intervention) {
    state.intervention = intervention;
  },
};

const actions = {
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
